import { render } from "./ActivityLog.vue?vue&type=template&id=45f62f6d&ts=true"
import script from "./ActivityLog.vue?vue&type=script&lang=ts"
export * from "./ActivityLog.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__